export const isPrivateSellerContract = ({contractId, privateContractId, whenMissingContractId}) =>
  contractId ? Number(contractId) === privateContractId : whenMissingContractId
